import { getSettingSaga } from './getSetting'
import { addSettingSaga } from './addSetting'
import { editSettingSaga } from './editSetting'

const demandeSagas = [getSettingSaga, addSettingSaga, editSettingSaga]

export default demandeSagas
